/* eslint-disable no-unused-vars */
import axios from "axios";
let urls =  {
  production: {
    paymentsURL: "http://localhost:7003",
    bucketUrl: "https://resources.wizztech.us/",
    ecomUrl: "https://ebuyings.com/",
    objectKey: "uploads/",
    tenantType:"all",//all or //BsvwPFic7vjzWPiy2
    translationLink: "https://resources.wizztech.us/static/stocks.json",
    pushNotifications:{
      apiKey: "AIzaSyCpv7czGbSObCNiPgYC030adCdPXUQoU2g",
      authDomain: "ebuyings-28f79.firebaseapp.com",
      projectId: "ebuyings-28f79",
      storageBucket: "ebuyings-28f79.appspot.com",
      messagingSenderId: "397458844239",
      appId: "1:397458844239:web:c8a9e5349080cccbbed83a",
      measurementId: "G-6K3JVWCVF2",
      VapIdKey: "BJMEtRZse16qZAMzMDwtt6a2WrMJCPhPnCtyhWFjaZjRoU9vuV6MvTQyCL6b51jtp5QYFjGcYRVhpSGEjmPQnQc"
    }
    
  },
  development: {
    paymentsURL: "http://localhost:7003",
    ecomUrl: "https://ebuyings.com/",
    bucketUrl: "https://resources.wizztech.us/",
    objectKey: "uploads/",
    tenantType:"all",
    translationLink: "https://resources.wizztech.us/static/stocks.json",
    pushNotifications:{
      apiKey: "AIzaSyCpv7czGbSObCNiPgYC030adCdPXUQoU2g",
      authDomain: "ebuyings-28f79.firebaseapp.com",
      projectId: "ebuyings-28f79",
      storageBucket: "ebuyings-28f79.appspot.com",
      messagingSenderId: "397458844239",
      appId: "1:397458844239:web:c8a9e5349080cccbbed83a",
      measurementId: "G-6K3JVWCVF2",
      vapidKey: "BJMEtRZse16qZAMzMDwtt6a2WrMJCPhPnCtyhWFjaZjRoU9vuV6MvTQyCL6b51jtp5QYFjGcYRVhpSGEjmPQnQc"
    }
  },
}

export function getUrls() {
  const live = localStorage.getItem('on') === "prod" 
  if(process.env.NODE_ENV == 'production' || live) {
    return urls.production
  } else {
    return urls.development
  }
}

let isFetched = false;
let isFetched2 = false;

export const loadConfig = async () => {
  console.log("loadConfig1");
  const tenantId = localStorage.getItem("tenantId");
  const allowedTenantIds = ["n4Xc96g6qyNcrq5dD", "jNrhXAynhAbQkrj8Y", "8wNWEtTEdgoywriNX"];

  if (allowedTenantIds.includes(tenantId))
  {  
    if(isFetched2)
      return;
  }
  else if(isFetched && !getUrls().translationLink) 
    return

  isFetched2 = true;
  isFetched = true;
  console.log("loadConfig3");
  try {
    const protocol = window.location.protocol;
    const key = (protocol == "http:" ? "stg" : "prod");
    //
    const url = {
      prod: "https://resources.wizztech.us/static/client/live.json",
      stg: "https://resources.wizztech.us/static/client/stg.json",
    };
    const server = localStorage.getItem("on") || key;
    localStorage.setItem("on", server);
    const response = await axios.get(url[server]);
    const data = response.data;
    // console.log("*****", data);
    //pnc-importjp-main
    const cfg = {
      sso: data?.http?.sso,
      fida: data?.http?.growth,
      inventoryURL: data?.http?.ebuyings,
      // inventoryURL: "http://localhost:7005/",

      //  sso: "https://sso.forgedrift.com/",
      // fida: "https://fida.forgedrift.com/",
      // inventoryURL: "https://ebuyings.forgedrift.com/",

      translationLink: data?.static?.stocks,

     

      // ...config,
    };
    const key2 = key === "prod" || localStorage.getItem("on") == "prod" ? "production": "development";
    urls = {...urls ,[key2]: {...urls[key2], ...cfg},};
    console.log("urls", urls);
    isFetched = true;
    return urls
  } catch (error) {
    isFetched = false
    console.error("There was a problem with the axios request:", error);
  }
};